import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { UserService } from './user.service';
import { Service } from '../models/service.model';
import { ServiceNames } from '../layouts/full/shared/Enums';



const BASE_URL = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) { }

  getServices() {
    const token = localStorage.getItem('token') || '';

    return this.http.get<{ services: Service[] }>(`${BASE_URL}/services/${this.userService.user.ID}`, {
      headers: {
        'X-Amz-Security-Token': token
      }
    }).pipe(
      map((resp: {services: Service[]}) => resp.services)
    );
  }

  getClientServices(clientId: string) {
    const token = localStorage.getItem('token') || '';

    return this.http.get<{ services: Service[] }>(`${BASE_URL}/services/${clientId}`, {
      headers: {
        'X-Amz-Security-Token': token
      }
    }).pipe(
      map((resp: {services: Service[]}) => resp.services)
    );
  }

  subscribe(name: string) {

    const token = localStorage.getItem('token') || '';

    return this.http.post(`${BASE_URL}/service`, {
      clientId: this.userService.user.ID,
      name,
      active: true
    }, {
      headers: {
        'X-Amz-Security-Token': token
      }
    })
  }

  subscribeClient(clientId: string, service: ServiceNames) {

    const token = localStorage.getItem('token') || '';

    return this.http.post(`${BASE_URL}/service`, {
      clientId,
      name: service,
      active: true
    }, {
      headers: {
        'X-Amz-Security-Token': token
      }
    })
  }

  subscribeGeneratePDFReport(clientId: string) {

    const token = localStorage.getItem('token') || '';

    return this.http.post(`${BASE_URL}/service`, {
      clientId,
      name: 'Pressure plate report',
      active: true
    }, {
      headers: {
        'X-Amz-Security-Token': token
      }
    })
  }
}
